export * from "./result-map-mobile.component";
